import { z } from "zod";

import { RSVPStatusEnum, matchModel } from "shared/types";

import { calendarEventObject } from "./MatchStatusEnum";

export const eventModel = z.object({
	soccer: z.object({
		calendarEvent: calendarEventObject.nullable().optional(),
		match: matchModel.nullable(),
		myAttendanceStatus: z.nativeEnum(RSVPStatusEnum).nullable().optional()
	})
});

export type EventModel = z.infer<typeof eventModel>;
